import styled from 'styled-components';
export const H1 = styled.h1.withConfig({
  displayName: "TwoFactorStyledComponents__H1",
  componentId: "sc-1r734je-0"
})(["font-size:20px;"]);
export const P = styled.p.withConfig({
  displayName: "TwoFactorStyledComponents__P",
  componentId: "sc-1r734je-1"
})(["margin-top:15px;"]);
export const TextAlignLeft = styled.div.withConfig({
  displayName: "TwoFactorStyledComponents__TextAlignLeft",
  componentId: "sc-1r734je-2"
})(["text-align:left;"]);
export const LinkSpace = styled.div.withConfig({
  displayName: "TwoFactorStyledComponents__LinkSpace",
  componentId: "sc-1r734je-3"
})(["margin-top:20px;"]);
export const AlertWrapper = styled.div.withConfig({
  displayName: "TwoFactorStyledComponents__AlertWrapper",
  componentId: "sc-1r734je-4"
})(["margin:20px 0;"]);